import React from 'react';

function SkillCard({ name, icon }) {
  return (
    <div className="h-18 sm:h-20 md:h-24 lg:h-28 xl:h-32 flex flex-col items-center justify-center hover:bg-zinc-700 hover:-translate-y-2 transition duration-200">
      <div>
        <i className={ `${ icon } text-slate-100 text-4xl sm:text-5xl md:text-6xl lg:text-7xl hover:text-red-400` }></i>
      </div>
      <h2 className="text-slate-100 hover:text-lightGreen font-semibold text-center lg:text-lg">{ name }</h2>
    </div>
    );
}

export default SkillCard;
